<script>
import Main from './main.vue';

export default Main.extend({
  computed: {
    seriesData() {
      return this.graphicsData.map((line, ind) => {
        const qaItem = this.qaModelsList.find((el) => el.ID === line.Id);
        const data = line.KpiData[0];
        return {
          name: `${qaItem.Name}`,
          data: [{
            x: ind,
            y: data.Rating,
            qa: {
              score: data.Rating,
              level: data.QualityLevel,
            },
            reports: data.ErrorItemStatisticsData.Total,
          }],
        };
      });
    },
  },
});
</script>
